export const env = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT || "http://localhost:1337"
};
